// extracted by mini-css-extract-plugin
module.exports = {"jenga-item":"jenga-item_jenga-item__5nLYh","title":"jenga-item_title__7Hktj","body":"jenga-item_body__oi7FY"};